import { Link } from 'react-router-dom';
import { Stethoscope } from 'lucide-react';
import './MarketingFooter.css';

const MarketingFooter = () => {
  return (
    <footer className="landing-footer">
      <div className="landing-footer-container">
        <div className="landing-footer-grid">
          <div className="landing-footer-brand">
            <div className="landing-footer-logo">
              <Stethoscope size={24} />
              <span>Amplify by CareTracker</span>
            </div>
            <p className="landing-footer-tagline">
              HIPAA-compliant medical AI platform transforming clinical
              documentation.
            </p>
          </div>

          <div className="landing-footer-links">
            <h3 className="landing-footer-heading">Product</h3>
            <ul>
              <li>
                <Link to="/features">Features</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <a href="#">API Docs</a>
              </li>
            </ul>
          </div>

          <div className="landing-footer-links">
            <h3 className="landing-footer-heading">Company</h3>
            <ul>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <a href="#">Careers</a>
              </li>
            </ul>
          </div>

          <div className="landing-footer-links">
            <h3 className="landing-footer-heading">Legal</h3>
            <ul>
              <li>
                <Link to="/privacy">Privacy</Link>
              </li>
              <li>
                <Link to="/terms">Terms</Link>
              </li>
              <li>
                <Link to="/eula">EULA</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="landing-footer-bottom">
          <p>&copy; 2025 Amplify by CareTracker. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default MarketingFooter;
